import React, { useEffect, useMemo, useState } from "react";
import Paycards from "./Paycards";
import order from "../../assets/images/svgs/cards/orders.svg";
import { GoSun } from "react-icons/go";
import Paydetail from "../Modals/Paydetail";
import { useDispatch, useSelector } from "react-redux";
import { getPaymentHistory } from "../../redux/thunks/customerRecordThunk";
import Pagination from "../Pagination";

const formatDate = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};



const Pay = ({ currentDate, customerId }) => {
  const [openpaydetail, setOpenpaydetails] = useState(false);
  // console.log("The customer id is :", customerId);
  const [payDetail, setPayDetail] = useState([]);
  const [Curr, setCurr] = useState("");
  const dispatch = useDispatch();

  const { pagination, isCustmerLoading } = useSelector(
    (state) => state.customerRecords,
  );
  const { current_page, total_pages, total_records } = pagination;
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (!customerId || !currentDate) return;

    const startDate = formatDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
    );

    const endDate = formatDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0),
    );

    // console.log("The start date is :", startDate);
    // console.log("The end date is :", endDate);

    dispatch(
      getPaymentHistory({
        service_provider_customer_id: customerId,
        page: page,
        start_date: startDate,
        end_date: endDate,
      }),
    )
      .unwrap()
      .then((res) => {
        // console.log("The res is :", res.data);
        setPayDetail(res?.data?.payments || []);

        const getCur = res.data?.currency_symbol;
        setCurr(getCur);
      });
  }, [dispatch, customerId, currentDate]);

  const [selectedCard, setSelectedCard] = useState(null);

  const cardData = useMemo(() => {
    return payDetail.map((item) => ({
      id: item.transaction_id,
      amount: `${Curr}${Number(item.amount).toFixed(2)}`,
      description: item.date_time, // date-time
      refId: item.payment_unique_id,
      orderDate: item.date_time,
      mealType: "Lunch",
      orderNum: "--",
      orderImg: order,
      payment: item.payment_type,
      mealIcon: <GoSun size={15} />,
      raw: item,
    }));
  }, [payDetail]);

  const handleCardClick = (card) => {
    setSelectedCard(card);
    setOpenpaydetails(true);
  };

  const filteredCards = useMemo(() => {
    return cardData.filter((card) => {
      const d = new Date(card.orderDate);
      return (
        d.getMonth() === currentDate.getMonth() &&
        d.getFullYear() === currentDate.getFullYear()
      );
    });
  }, [cardData, currentDate]);

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {filteredCards.length === 0 ? (
          <p className="text-center text-gray-400 col-span-2 py-6">
            No Payments in this month
          </p>
        ) : (
          filteredCards.map((data) => (
            <Paycards
              key={data.id}
              subTitle={data.amount}
              description={data.description}
              orderImg={data.orderImg}
              mealIcon={data.mealIcon}
              refId={data.refId}
              mealType={data.mealType}
              orderNum={data.orderNum}
              paymentType={data.payment}
              onHandleDetails={() => handleCardClick(data.raw)}
            />
          ))
        )}
      </div>

      {payDetail.length > 0 && total_pages > 1 && (
        <Pagination
          current={current_page}
          total={total_pages}
          onPageChange={setPage}
          
        />
      )}

      {selectedCard && (
        <Paydetail
          open={openpaydetail}
          onClose={() => setOpenpaydetails(false)}
          card={selectedCard}
          currencySymbol={Curr}
        />
      )}
    </>
  );
};

export default Pay;
